/**
 * @file Onglet Collection : par grade, les 5 armes (silhouette grisee si jamais vue) et la recompense de grade complete.
 */
import { GRADES } from '@shared/enums';
import type { GradeId } from '@shared/enums';
import { Component } from '../../core/Component';
import { h, setText, toggleClass } from '../../core/dom';
import { send } from '../../core/feedback';
import { amountChip } from '../../core/widgets';
import type { UiContext } from '../../UiContext';
import { createTile } from './tile';

/** Recompense d'un grade complet : 50 x (index + 1) gemmes (GAME_DESIGN §8.4, appliquee par WeaponService.claimCollection). */
const GEMS_PER_GRADE_STEP = 50;

interface GradeView {
  grade: GradeId;
  progress: HTMLElement;
  claim: HTMLElement;
  tiles: Array<{ defId: string; root: HTMLElement }>;
}

export class CollectionPane extends Component {
  private readonly grades: GradeView[] = [];

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'collection');
  }

  protected build(): void {
    const t = this.ctx.i18n;
    for (const grade of GRADES) {
      const defs = this.ctx.index.weaponsOfGrade(grade);
      const progress = h('span', { class: 'col-progress' });
      const claim = h('button', { class: 'btn small', type: 'button', 'data-ui-block': true, onclick: () => void send(this.ctx, { type: 'weapon.claimCollection', grade }) }, t.t('common.claim'));
      const row = h('div', { class: 'col-tiles' });
      const tiles: GradeView['tiles'] = [];
      for (const def of defs) {
        const p = createTile(this.ctx, def, 'col-tile');
        row.append(p.root);
        tiles.push({ defId: def.id, root: p.root });
      }
      const reward = amountChip('dia', GEMS_PER_GRADE_STEP * (GRADES.indexOf(grade) + 1));
      this.el.append(
        h(
          'section',
          { class: 'col-grade panel', style: `--g:${this.ctx.index.grade(grade).colors.primary}` },
          h('div', { class: 'col-head' }, h('b', { class: 'col-grade-name' }, t.t('weapons.collectionReward', { grade })), progress),
          row,
          h('div', { class: 'col-foot' }, reward, claim),
        ),
      );
      this.grades.push({ grade, progress, claim, tiles });
    }
    this.update(0);
  }

  override update(_dt: number): void {
    const { query, data } = this.ctx.sim;
    for (const g of this.grades) {
      const p = query.collectionProgress(g.grade);
      setText(g.progress, `${p.seen}/${p.total}`);
      const complete = p.seen >= p.total;
      toggleClass(g.claim, 'disabled', !complete || p.claimed);
      toggleClass(g.claim, 'ready', complete && !p.claimed);
      setText(g.claim, p.claimed ? this.ctx.i18n.t('common.claimed') : this.ctx.i18n.t('common.claim'));
      for (const t of g.tiles) toggleClass(t.root, 'unseen', data.weapons.collection[t.defId]?.seen !== true);
    }
  }
}
